import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tag } from "@vapor/react-custom";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack, useTheme } from "@vapor/react-material";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { ActivityStatus } from "../../../core/dtos/ActivityStatus";
import { getActivityColorFromStatus } from "../../../utils/getColorsByStatus";
import { getLabelFromStatus } from "./getLabelFromStatus";

interface ActivityCounterProps {
    count?: number;
    hasWarnings?: boolean;
    numberOfWarnings?: number;
    status: ActivityStatus;
}

export const ActivityCounter = ({
    count,
    hasWarnings,
    numberOfWarnings,
    status,
}: ActivityCounterProps): ReactElement => {
    const { t } = useTranslation();
    const theme = useTheme();
    const warnings = numberOfWarnings ?? 0;
    const showWarning = hasWarnings || warnings > 0;

    return (
        <Stack
            alignItems="center"
            direction="row"
            overflow="hidden"
            spacing={1}
            whiteSpace="nowrap"
        >
            <Tag
                label={`${getLabelFromStatus(status, t, count)} ${
                    count ? `(${count})` : ""
                }`}
                variant="ghost"
                type={getActivityColorFromStatus(status)}
            />
            <FontAwesomeIcon
                color={
                    showWarning
                        ? theme.palette.primary.baseWarningColor
                        : "transparent"
                }
                icon={faTriangleExclamation}
                size="lg"
            />
            {warnings > 0 && (
                <Typography
                    color={theme.palette.primary.textTitleColor}
                    overflow="hidden"
                    textOverflow="ellipsis"
                    variant="subtitle"
                >
                    {`(${warnings})`}
                </Typography>
            )}
        </Stack>
    );
};
